import React, { Component } from 'react';
import { BrowserRouter as Router, Redirect } from 'react-router-dom';
import { publicMenu } from 'constantes/index';
import Alert from 'react-s-alert';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import {Plantilla} from 'components';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import UserAccount from 'pages/Security/Login/FormElements/UserAccount';

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            authenticated : false,
            loading: false,
            userAccount:new UserAccount(),
        }
    }

    async componentDidMount() {
        this.setState({ loading: true  });
        try{
            await this.state.userAccount.setCurrentUser();
            await this.state.userAccount.setMenu();
            if (this.state.userAccount.getIsError()){
                Alert.error(this.state.userAccount.getErrorMessage());
                this.setState({ loading: false  });
            }else{
                this.props.SET_MENU(this.state.userAccount.getMenu());
                this.props.SET_CURRENT_USER(this.state.userAccount.getCurrentUser());
                this.setState({authenticated:this.state.userAccount.getIsAuthenticated, loading:false});
            }
        }catch(error){
            this.props.SET_MENU(publicMenu);
            this.setState({ loading: false  });
        }
    }

    render() {
        if (this.state.loading) return (<IndicadorDeCarga open={this.state.loading} />);
        if (this.state.authenticated)
            return <Redirect
                        to={{
                        pathname: "/",
                        state: { from: this.props.location, authenticated: this.state.authenticated }
                    }}/>;

        return (
            <Router>
                <Plantilla />
            </Router>
        );
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(App);